module.exports = __webpack_public_path__ + "static/img/provider-lib.1856edc4.svg";